<script>
  import { tempStore } from "../../../stores/temp.store";
  import Icon from "../../../components/Icon/Icon.svelte";
  import get from "get-value";
  import { viditelnostTabu } from "../sidebarLeft.func";

  const kodMenu = "systemoveInfo";
  let open = false;

  const unsubscribe = tempStore.subscribe((value) => {
    viditelnostMenu(value);
  });

  function viditelnostMenu(value) {
    let menu = get(value, "menu");
    open = kodMenu === menu;
  }
</script>

<!-- Tab change map start -->
<div
  class="sidebar__tab sidebar__tab--map"
  class:js-tab--open={open}
  data-tab="2"
>
  <div
    class="sidebar__close"
    on:click|preventDefault={() => viditelnostTabu(kodMenu)}
  >
    <Icon kod="012" />
  </div>
  <div class="sidebar__wrapper">
    <h6 class="sidebar__heading">Informácie o systéme</h6>
    <p>Smartmap - systém pre komplexnú integráciu údajov</p>
    <p>
      Neváhajte sa na nás obrátiť s akýmikoľvek otázkami, komentármi alebo
      postrehmi...
    </p>
    <p>
      Email:<br /><strong
        ><a href="mailto:info@smartmap.sk">info@smartmap.sk</a></strong
      >
    </p>
    <p>Obchodné oddelenie:<br /><strong>+421 2 5930 7013</strong></p>
    <p>Zákaznícka linka:<br /><strong>+421 2 5930 7011</strong></p>
    <p class="text-small">
      Smartmap v 4.1<br />
      Adresné body LoRAB®, Cestno-uličný systém, DEM ©2022 ErasData-Pro s.r.o.<br
      />
      Ortofotomozaika, ZBGIS ©2022 GKÚ Bratislava
    </p>
    <p class="text-small">
      Informačný systém katastra nehnuteľností ©2022 ÚGKK SR
    </p>
    <p class="text-small">Ortofotomozaika ©GKÚ, NLC</p>
  </div>
</div>

<!-- Tab description end -->
<style>
  .text-small {
    font-size: 80%;
  }
</style>
